'use client';

import { useSweetLinkAutoBootstrap } from '@/hooks/useSweetLinkAutoBootstrap';

export function SweetLinkAutoBootstrap(): null {
  useSweetLinkAutoBootstrap();
  return null;
}
